
(() => {
  const API = 'https://oto.ge/cart-share/api.php';
  const $ = id => document.getElementById(id);

  const saveBtn   = $('save-cart-btn');
  const area      = $('cart-link-area');
  const linkInput = $('share-link');
  const waBtn     = $('wa-share');
  const copyBtn   = $('copy-btn');

  const wait = ms => new Promise(r => setTimeout(r, ms));

  const getCart = async () => {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    const text = await res.text();
    try { return JSON.parse(text); }
    catch {
      await fetch('/cart', { credentials: 'same-origin' });
      await wait(300);
      const r2 = await fetch('/cart.js', { credentials: 'same-origin' });
      return r2.json();
    }
  };

  const normalize = items => (items || []).map(i => ({ id: i.variant_id, quantity: i.quantity }));

  const isEnglish = document.documentElement.lang === 'en';
  const t = key => {
    const en = {
      save: '💾 Save Cart',
      saving: '⏳ Saving...',
      empty: 'Cart is empty',
      loading: '⏳ Loading your saved cart...',
      failed: '❌ Failed to load cart.',
      saved: '✅ Saved',
      updated: '✅ Updated',
      forked: '🆕 Created new cart',
      notAdded: 'Some products were unavailable and not added.'
    };
    const ka = {
      save: '💾 კალათის შენახვა',
      saving: '⏳ ინახება...',
      empty: 'კალათა ცარიელია',
      loading: '⏳ კალათის ჩატვირთვა...',
      failed: '❌ ვერ ჩაიტვირთა კალათა.',
      saved: '✅ შეინახა',
      updated: '✅ განახლდა',
      forked: '🆕 შეიქმნა ახალი კალათა',
      notAdded: 'ზოგიერთი პროდუქტი ამოწურულია და კალათაში არ დაემატა.'
    };
    return (isEnglish ? en : ka)[key];
  };

  const token = sessionStorage.getItem('cartToken') || Math.random().toString(36).slice(2);
  sessionStorage.setItem('cartToken', token);

  // 💾 Save / Update Cart (button loader)
  async function saveCart() {
    if (!saveBtn) return;
    const originalText = saveBtn.textContent;
    saveBtn.textContent = t('saving');
    saveBtn.disabled = true;

    const savedId = sessionStorage.getItem('savedCartId');
    const action = savedId ? `update&id=${savedId}` : 'save';

    try {
      const cart = await getCart();
      const items = normalize(cart.items);
      if (!items.length) { alert(t('empty')); return; }

      const res = await fetch(`${API}?action=${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, items })
      });
      const data = await res.json();
      if (!data.cartId) throw new Error('Invalid response');

      sessionStorage.setItem('savedCartId', data.cartId);
      area?.classList.remove('hidden');
      const url = `${location.origin}/cart?id=${data.cartId}`;
      linkInput && (linkInput.value = url);
      waBtn && (waBtn.href = `https://wa.me/?text=${encodeURIComponent(' ' + url)}`);

      const status = data.status;
      saveBtn.textContent = t(status === 'updated' ? 'updated' : status === 'forked_new' ? 'forked' : 'saved');
      setTimeout(() => (saveBtn.textContent = t('save')), 2000);
    } catch (err) {
      console.error('Save error:', err);
      alert(t('failed'));
    } finally {
      saveBtn.disabled = false;
      // restore after short delay if it’s still on “⏳ Saving...”
      setTimeout(() => {
        if (saveBtn.textContent === t('saving')) saveBtn.textContent = originalText;
      }, 400);
    }
  }

  saveBtn?.addEventListener('click', saveCart);

  // 📋 Copy
  copyBtn?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(linkInput?.value || '');
      copyBtn.textContent = '✅';
      setTimeout(() => (copyBtn.textContent = '📋 Copy'), 1000);
    } catch {
      if (linkInput) { linkInput.select(); document.execCommand('copy'); }
    }
  });

  // 🚀 Load Shared Cart (incognito-safe)
  (async () => {
    const id = new URLSearchParams(location.search).get('id');
    if (!id) return;

    const overlay = document.createElement('div');
    overlay.textContent = t('loading');
    Object.assign(overlay.style, {
      position: 'fixed',
      inset: 0,
      background: 'rgba(255,255,255,0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      zIndex: 9999
    });
    document.body.appendChild(overlay);

    try {
      const res = await fetch(`${API}?action=get&id=${encodeURIComponent(id)}`);
      const data = await res.json();
      if (!Array.isArray(data.items) || !data.items.length) throw new Error('No items');

      const first = data.items[0];
      if (first?.id) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: first.id, quantity: 1 })
        });
        await wait(300);
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
      }

      const unavailable = [];
      for (const { id: pid, quantity } of data.items) {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: pid, quantity })
        });
        if (!r.ok) unavailable.push(pid);
      }

      if (unavailable.length) {
        const msg = document.createElement('div');
        msg.innerHTML = `<div style="background:#fff3cd;border:1px solid #ffeeba;padding:12px;border-radius:8px;max-width:520px;margin:20px auto;text-align:center;">⚠️ ${t('notAdded')}</div>`;
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 4000);
      }

      location.href = '/cart';
    } catch (e) {
      console.error('Load error', e);
      overlay.textContent = t('failed');
      setTimeout(() => overlay.remove(), 2000);
    }
  })();

  // 🔗 Restore saved link for owner
  (() => {
    const savedId = sessionStorage.getItem('savedCartId');
    if (!savedId) return;
    area?.classList.remove('hidden');
    const url = `${location.origin}/cart?id=${savedId}`;
    if (linkInput) linkInput.value = url;
    if (waBtn) waBtn.href = `https://wa.me/?text=${encodeURIComponent('' + url)}`;
  })();
})();